export let consoleProjects = [
    {
        title: "Calculator",
        link: "https://github.com/VocalNight/Calculator_CSharp",
        description: "A small calculator in C#"
    },
    {
        title: "Habit Logger",
        link: "https://github.com/VocalNight/HabitLogger_Csharp",
        description: "Small program to track habits of your chosing."
    },
    {
        title: "Coding Tracker",
        link: "https://github.com/VocalNight/CodingTracker",
        description: "Similar to the habit tracker but for coding."
    },
    {
        title: "Flashcards",
        link: "https://github.com/VocalNight/Flashcards_CSharp",
        description: "A small project to achieve something similar to Anki, but in a small scale."
    },
    {
        title: "Drinks Info",
        link: "https://github.com/VocalNight/DrinksInfo",
        description: "A simple program to fetch data from an API."
    },
    {
        title: "Phone Book",
        link: "https://github.com/VocalNight/PhoneBook",
        description: "A way to store contacts and friends information. Developed to get used to DB interactions in C#"
    },
    {
        title: "Shift Logger",
        link: "https://github.com/VocalNight/ShiftsLogger",
        description: "A more robust console project and an experiment in creating an API and consuming it. Got me interested in microservices."
    },
    {
        title: "Exercise Tracker",
        link: "https://github.com/VocalNight/Exercise-Tracker",
        description: "A more robust tracker, this time using Entity Framework, the C# ORM."
    },
    {
        title: "Sports Results Notifier",
        link: "https://github.com/VocalNight/SportsNotifier",
        description: "Used this one to practice how to scrap data from websties using C# features"
    },
    {
        title: "Excel Reader",
        link: "https://github.com/VocalNight/ExcelReader",
        description: "How to transform data from the Database into an Excel spreadsheet."
    }

]
